import { match } from "ts-pattern";

/** How an item is answered: rated, or yes or no, stored as 1 or 0. */
export type RatingScale = "rating" | "yes_no";

/**
 * The scale the values an item offers make: yes or no where the numbers among
 * them are exactly 0 and 1. Told from the values, which mean the same in
 * every instrument, rather than from a response set's id, which is each
 * instrument's own name for it.
 */
export const scaleOf = (values: readonly (string | number)[]): RatingScale => {
  const numbers = values.filter((value) => typeof value === "number");

  return numbers.length === 2 && numbers.includes(0) && numbers.includes(1)
    ? "yes_no"
    : "rating";
};

/**
 * Where an answer stands among the ratings 0 to 3 that colours and orders
 * are set by: a yes is the top of its scale, as a 3 is of a rating.
 */
export const levelOf = ({
  scale,
  rating,
}: {
  scale: RatingScale;
  rating: number;
}): number =>
  match(scale)
    .with("yes_no", () => rating * 3)
    .with("rating", () => rating)
    .exhaustive();
